import {gql} from '@apollo/client';

export const LIST_PAYOUT = gql`
    query listPayouts($limit: Int!){
        listPayouts(limit: $limit){
            hasMore
            payouts{
                id
                amount
                currency
                arrival_date
                created
                description
                failure_balance_transaction
                failure_code
                failure_message
                status
                type
            }
        }
    }
`